const wizard = {
    prefixTemplate: ({ id, simulationId }) => `/rip/${id}/simulations/${simulationId}`,
    items: [
        {
            name: 'Produits',
            target: 'products',
        },
        {
            name: 'Simulation',
            target: 'simulation',
        },
    ],
};

export default wizard;
